<template>
  <v-dialog v-model="show_dialog" width="500" persistent>
    <v-card>
      <v-card-title class="secondary white--text">
        Create Template
        <v-spacer></v-spacer>
        <v-btn icon dark @click="show_dialog=false">
          <v-icon>fa-times</v-icon>
        </v-btn>
        <v-progress-linear :active="loading" :indeterminate="loading" absolute top color="primary"></v-progress-linear>
      </v-card-title>
      <v-container>
        <v-row align="center">
          <v-col cols="12" v-if="portal">
            <v-text-field
              outlined
              hide-details
              label="From Portal"
              :value="portal.title"
              disabled
              readonly
            ></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-text-field outlined hide-details label="Name" v-model="name"></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-select outlined hide-details :items="['Event','Business']" v-model="type"></v-select>
          </v-col>
          <v-col cols="12">
            <v-text-field outlined hide-details label="Icon" :append-icon="icon" v-model="icon"></v-text-field>
          </v-col>
        </v-row>
      </v-container>
      <v-card-actions class="grey lighten-3">
        <v-spacer></v-spacer>
        <v-btn color="primary" dark @click="create" :loading="loading">Create</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  name: "AdminCreateTemplate",
  data: () => ({
    show_dialog: false,
    name: "",
    type: "Event",
    icon: "fa-church",
    portal: null,
    loading: false
  }),
  created() {
    this.$eventBus.$on("create_template", this.open);
  },
  methods: {
    async open(portal) {
      this.show_dialog = true;
      this.portal = portal;
      this.name = portal.name;
    },
    async create() {
      this.loading = true;
      try {
        await this.$api.post(`/admin/templates`, {
          portal_id: this.portal.id,
          name: this.name,
          type: this.type,
          icon: this.icon,
          title: this.portal.title,
          description: this.portal.description,
          settings: this.portal.settings,
          sections: this.portal.sections
        });
        this.show_dialog = false;
        this.$router.push("/admin/templates");
      } catch (ex) {
        alert(ex.error);
      }
      this.loading = false;
    }
  }
};
</script>
<style lang="scss" scoped>
</style>
